import React from 'react'
import Box from '@mui/material/Box'
import TableSort from '../tableComponents/TableSort'
import { formatDateRange, formatHourFilter, formatMonthFilter, formatDowFilter } from "../js/utilityRoutines"

export default function BintempsTable(props) { 
  const { tabledata, estcnt, misscnt, totobscnt, userParams, stnName } = props;
  const dateRange = formatDateRange(userParams);
  const monthFilter =  formatMonthFilter(userParams);
  const dowFilter = formatDowFilter(userParams);
  const hourFilter = formatHourFilter(userParams);
  const sumObs = totobscnt.toLocaleString("en")
  const sumEst = estcnt.toLocaleString("en")
  const sumMiss = misscnt.toLocaleString("en")
  const titleText = "Hourly Bin Temperature Summary<br/ >" + stnName;
  const footerText = "Based on a total of "+sumObs+" hourly observations ("+sumEst+" estimated); "+sumMiss+" missing."+
    "<br />" + dateRange +
    (monthFilter ? "<br />" : "") + monthFilter +
    (dowFilter ? "<br />" : "") + dowFilter +
    (hourFilter ? "<br />" : "") + hourFilter;
  const heads = [
    {text: 'index', id: 'index', invisible: true, initSort: true, sortOrder: 'desc'},
    {text: 'Temperature Range (degF)', id: 'range', altSort: 'index'},
    {text: 'Count (hours)', id: 'count'},
    {text: ' Mean Wet Bulb (degF)', id: 'mwetb'}
  ]

  return (
    <Box sx={{my: 1}}>
      <TableSort 
        titleText={titleText} 
        heads={heads}  
        tabledata={tabledata} 
        footerText={footerText}
      />
    </Box>
  )
}
